// extracted by mini-css-extract-plugin
export default {"title":"KnowledgeBaseItemChildren_title__NVb7G"};